<template>
  <DxButtonGroup :items="items" :selected-item-keys="[lang]" key-expr="key" selection-mode="single"
                 styling-mode="outlined" @selection-changed="onChanged"/>
</template>

<script>
import {tr as __tr} from '@/utils/develop-lang';
import DxButtonGroup from "devextreme-vue/button-group";
import {currentLang, setLang} from "@/utils/develop-lang";

// EN/DE-Schalter des aktuellen Develop-Screens
export default {
  name: "develop-language-switch",

  components: {DxButtonGroup},

  props: {
    // false: Screen nicht neu aufbauen (z.B. im geöffneten Detail-Panel)
    remount: {type: Boolean, default: true}
  },

  computed: {
    lang() {
      return currentLang();
    },

    items() {
      return [{key: 'en', text: __tr('EN')}, {key: 'de', text: __tr('DE')}];
    }
  },

  methods: {
    onChanged(e) {
      const key = e.addedItems && e.addedItems[0] ? e.addedItems[0].key : null;
      if (key && key !== currentLang()) setLang(key, this.remount);
    }
  }
};
</script>
